const MINUTES_PER_HOUR = 60;
const DECIMAL_RADIX = 10;
const GMT_OFFSET_PATTERN = /GMT([+-]\d{1,2}(?::(\d{2}))?)?$/;

/**
 * Checks whether two IANA timezone identifiers have the same UTC offset.
 * Compares actual offsets rather than string names so that, e.g.,
 * "Europe/Berlin" and "Europe/Paris" are treated as equivalent.
 */
export function hasSameUtcOffset(
  timezoneA: string,
  timezoneB: string,
  referenceDate?: Date
): boolean {
  if (timezoneA === timezoneB) return true;
  const timestamp = (referenceDate ?? new Date()).getTime();
  return getUtcOffsetMinutes(timezoneA, timestamp) === getUtcOffsetMinutes(timezoneB, timestamp);
}

function getUtcOffsetMinutes(timeZone: string, timestamp: number): number {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'shortOffset',
  });
  const parts = formatter.formatToParts(new Date(timestamp));
  const offsetPart = parts.find((part) => part.type === 'timeZoneName')?.value ?? '';

  // shortOffset produces strings like "GMT", "GMT+1", "GMT-5:30"
  const match = offsetPart.match(GMT_OFFSET_PATTERN);
  if (!match || !match[1]) return 0;

  const hours = parseInt(match[1], DECIMAL_RADIX);
  const minutes = parseInt(match[2] ?? '0', DECIMAL_RADIX);
  const sign = hours < 0 ? -1 : 1;
  return hours * MINUTES_PER_HOUR + sign * minutes;
}
